import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { FieldLabelIconMui5 } from 'components/atoms/FieldLabelIcon';
import Switch, { SwitchButtonItem } from 'components/molecules/Switch';
import { quoteAtom, scanModeInputAtom } from 'containers/deal/recoil/atoms';
import { MouseEvent, useEffect, useMemo, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useFilters } from 'services/filters/hooks/useFilters';
import { DealTypeEnum } from 'shared/types/endpoints';
import { MSAPIScanMode } from 'shared/types/marketScan';
import { UppercaseMui5 } from '../components';

export const LeaseFinanceToggle = ({
  withTitle,
  disabled = false,
  setFilter = false,
}: {
  withTitle?: boolean;
  disabled?: boolean;
  setFilter?: boolean;
}) => {
  const quote = useRecoilValue(quoteAtom);
  const [scanMode, setScanMode] = useRecoilState(scanModeInputAtom);
  const { filters, setFilterValue } = useFilters();

  const dealTypeMemo = useMemo(() => {
    return filters.dealType;
  }, [filters.dealType]);
  const [isInputHandled, setIsInputHandled] = useState(false);

  useEffect(() => {
    if (isInputHandled) {
      setIsInputHandled(false);
      return;
    }
    setScanMode(
      dealTypeMemo === DealTypeEnum.FINANCE
        ? MSAPIScanMode.Retail
        : MSAPIScanMode.Lease,
    );
  }, [dealTypeMemo, setScanMode, setIsInputHandled]);

  const quoteScanMode = quote?.program.FullDetails.Retail
    ? MSAPIScanMode.Retail
    : MSAPIScanMode.Lease;

  return (
    <Switch
      disabled={Boolean(quote)}
      title={
        withTitle
          ? ((
              <UppercaseMui5>
                <FieldLabelIconMui5 icon={faClock} color='primary' />
                Lease or Finance
              </UppercaseMui5>
            ) as any)
          : null
      }
      value={!quote ? scanMode : quoteScanMode}
      onChange={(e: MouseEvent<HTMLElement>, mode) => {
        if (mode == null || disabled) {
          return;
        }
        setScanMode(mode);
        if (setFilter) {
          const dealType =
            mode === MSAPIScanMode.Retail
              ? DealTypeEnum.FINANCE
              : DealTypeEnum.LEASE;

          setFilterValue('dealType', dealType);
          setIsInputHandled(true);
        }
      }}
      size='small'
      items={
        [
          { value: MSAPIScanMode.Lease, label: 'Lease' },
          { value: MSAPIScanMode.Retail, label: 'Finance' },
        ] as SwitchButtonItem[]
      }
      aria-label='text formatting'
    />
  );
};
